const hostname = window.location.hostname;

export const TicketingApiUri =
  hostname === "advent.endevre.com"
    ? "https://api.endevre.com/v2/ticketing/"
    : "https://apidev.endevre.com/v2/ticketing/";
export const endevreIDURL =
  hostname === "advent.endevre.com"
    ? "https://id.endevre.com/"
    : "https://idnextdev.endevre.com/";
export const apiKey = "key";
export const keepAuthPassPhrase = "3kch10doen8i5mqt";

export const vendorTier = {
  FREE: 0,
  BASIC: 1,
  PRO: 2,
  PRO_PHYSICAL: 3,
  PRO_PHYSICAL_COLOR: 4,
  PRO_PHYSICAL_NFC: 5,
  PRO_PHYSICAL_COLOR_NFC: 6,
};

export const loadState = {
  LOADING: 0,
  SUCCESS: 1,
  ERROR: 2,
};

export const Edit = {
  DEFAULT: 0,
  SAVING: 1,
  SAVE: 2,
};
